import { AxiosInstance } from "axios"
import {
    MerchantSalesMerchants,
    MerchantSalesMerchantsDetails,
    MerchantSalesMerchantsForExport,
    MerchantSalesReportData,
} from "./merchantSalesTypes"
import { MonetaryAmount } from "../../../../currency/currencyTypes"
import { DateType } from "../../../../../shared/components/filters/selectDateTypeFilter/SelectDateTypeFilter"
import { OrderFilterType } from "../../../../../shared/components/filters/orderTypeFilter/helpers"

export enum SupplierMerchantSalesQuery {
    MERCHANT_SALES_FOR_SUPPLIER = "merchant-sales-for-supplier",
    MERCHANT_SALES_FOR_SUPPLIER_DETAILS = "merchant-sales-for-supplier-details",
    MERCHANT_SALES_FOR_EXPORT = "merchant-sales-for-export",
}

export type MerchantSalesParams = Readonly<{
    supplierId: number
    shopTypes: string
    paymentMethods: string
    startDate: string
    endDate: string
    orderType: OrderFilterType
    dateType: DateType
}>

export type MerchantSalesDetailsParams = Readonly<{
    supplierId: number
    merchantId: number
    shopTypes?: string
}>

export type MerchantSalesForExportParams = Readonly<{
    supplierId: number
    startDate: string
    endDate: string
}>

export type SupplierMerchantSalesResponse = Readonly<{
    reportDetails: MerchantSalesReportData
    merchants: Array<MerchantSalesMerchants>
    totalBookedSales: MonetaryAmount
    totalUpcomingSales: MonetaryAmount
}>

export type SupplierMerchantSalesDetailsResponse = Readonly<{
    reportDetails: MerchantSalesReportData
    merchants: MerchantSalesMerchantsDetails
}>

export type SupplierMerchantSalesForExportResponse = Readonly<{
    reportDetails: MerchantSalesReportData
    merchants: MerchantSalesMerchantsForExport[]
}>

export async function fetchMerchantSales(
    { supplierId, startDate, endDate, shopTypes, paymentMethods, orderType, dateType }: MerchantSalesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupplierMerchantSalesResponse> {
    const url = `/suppliers/${supplierId}/accounting/merchants/sales`
    const { data } = await axios.get(url, {
        params: {
            shopTypes,
            paymentMethods,
            startDate,
            endDate,
            orderType,
            dateType,
        },
        signal,
    })

    return data
}

export async function fetchMerchantSalesDetails(
    { supplierId, shopTypes, merchantId }: MerchantSalesDetailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupplierMerchantSalesDetailsResponse> {
    const url = `/suppliers/${supplierId}/accounting/merchants/${merchantId}/salesPerCategory`

    const { data } = await axios.get(url, {
        params: {
            shopTypes,
        },
        signal,
    })

    return data
}

export async function fetchMerchantSalesForExport(
    { supplierId, startDate, endDate }: MerchantSalesForExportParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupplierMerchantSalesForExportResponse> {
    const url = `/suppliers/${supplierId}/accounting/merchants/salesPerCategory`
    const { data } = await axios.get(url, {
        params: {
            startDate,
            endDate,
        },
        signal,
    })

    return data
}
